selectUserCanPurchaseGift